import { logStartCoreUsage } from 'owa-analytics-start';

function isISO8859Valid(str: string) {
    return !/[^\u0000-\u00ff]/g.test(str);
}

// Evaluate the header to be ISO-8859-1 char safe before setting it.
// Non-ISO-8859-1 cannot be set on the header. It will cause the headers.Set function to throw the exception.
export function canSetHeaderISO8859Safe(headerName: string, headerValue: string): boolean {
    if (isISO8859Valid(headerValue)) {
        return true;
    } else {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logStartCoreUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logStartCoreUsage('ISO8859ValidHeaderForbootFlights', undefined, {
            errorHeaderName: headerName,
            errorHeaderValue: headerValue,
        });
        return false;
    }
}
